import React from 'react';
import ReactDOM from 'react-dom';
// import { Route, Switch, Redirect } from 'react-router-dom' // react-router v4
// import { Provider } from 'react-redux';
// import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';

import App from './App';

// import './md/assets/scss/material-dashboard-pro-react.scss?v=1.5.0';
// import './md/assets/scss/material-dashboard-pro-react.scss';

import configureStore from './store/configureStore';
import { loadState, saveState } from './store/reduxPersist';
import ReduxAccess from './store/ReduxAccess';
import ReduxLoader from './store/ReduxLoader';
import FormProcessor from './common/FormProcessor';

const hist = createBrowserHistory();

const continueAfterLoadingReduxState = (loadedState) => {
  const initialState = loadedState;
  const store = configureStore(hist, initialState);

  // MKM arrange to save redux store to local storage every time it changes
  store.subscribe(() => saveState(store.getState()));

  // MKM set up direct acccess to Redux store
  ReduxAccess.setStore(store);
  ReduxLoader.setStore(store);
  FormProcessor.setStore(store);

  const onLocalMachine = window.location.hostname === 'localhost';

  /*
  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={hist}>
        <Switch>
          <Route path="/homeDispatcher" component={HomeDispatcher} />
          <Route path="/unauthenticated" component={Unauthenticated} />
          <Route path="/unauthorized" component={Unauthorized} />
          <Route path="/unknownApiFailure" component={UnknownApiFailure} />
          <Route path="/u/" component={UserLayout} />
          <Route path="/sa/" component={SuperAdminLayout} />
          <Route path="/ar/" component={AllevaRepLayout} />
          <Route path="/p/" component={PlainLayout} />
          <Route path="/dev/" component={DevLayout} />
          <Route path="/dm/" component={DevModeLayout} />
          {onLocalMachine ? <Redirect from="/" to="/dev/home" /> : <Redirect from="/" to="/homeDispatcher" />}
        </Switch>
      </ConnectedRouter>
    </Provider>,
    document.getElementById("root")
  );
  */

  ReactDOM.render(<App store={store} hist={hist} onLocalMachine={onLocalMachine} />, document.getElementById('root'));
};

// Get the application-wide store instance, prepopulating with state from the server where available.
//    We don't do this because we do no server-side rendering
//    const windowState = window.initialReduxState;
// But we do want to pre-populate it with our saved state
loadState((loadedState) => continueAfterLoadingReduxState(loadedState));
